var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBikeshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#081754;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#081754;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.6,4.1 15.4,4.1 19.8,16.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.8,
    y1: 5.8,
    x2: 6.8,
    y2: 5.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7.6,5.8 8.9,8.4 12.3,16.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "8.9,8.4 16.3,8.4 12.3,16.3 12.3,16.3 8.5,16.3 4.6,16.3 6.4,12.9 8.8,8.4 8.9,8.4  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 19.7,
    cy: 16.3,
    rx: 3.8,
    ry: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.6,18c-0.6,1.2-1.9,2-3.3,2c-2.1,0-3.8-1.7-3.8-3.7s1.7-3.7,3.8-3.7s3.8,1.7,3.8,3.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeshare);
export default __webpack_public_path__ + "static/media/bikeshare.aab2d9f6b8223ff6eef423794f929919.svg";
export { ForwardRef as ReactComponent };